import { Box } from "@mui/material"
import { MainPageContentContainer } from "components/MainPageContentContainer"
import { VehicleContainer } from "layouts/card-holder/vehicles/container.tsx"
import { CardHolderPageProvider } from "layouts/card-holder/context/provider"
import { CardHolderFilter } from "layouts/card-holder/filter/cardHolderFilter.tsx"
import { OreveFooter } from "components/OreveFooter.tsx"
import { OreveButton } from "components/button/OreveButton.tsx"
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useCardHolderContext } from "layouts/card-holder/context/useCardHolderContext.ts"
import { useOrganization } from "context/OrganizationContext"

export const VehiclePage = () => {
    const { organizationId } = useOrganization()

    return (
        <CardHolderPageProvider key={organizationId ?? "no-org"}>
            <VehiclePageView />
        </CardHolderPageProvider>
    )
}
const VehiclePageView = () => {
    const { setOpenAddCardHolder } = useCardHolderContext()
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: "1.5rem",
            }}
        >
            <CardHolderFilter />
            <MainPageContentContainer
                sx={{
                    p: "2.25rem",
                }}
            >
                <VehicleContainer />
            </MainPageContentContainer>
            <OreveFooter>
                <OreveButton
                    icon={AddCircleOutlineIcon}
                    value="Ajouter un véhicule"
                    data-cy="nav_drivers__footer--add-vehicle"
                    variant="contained"
                    color="primary"
                    onClick={() => setOpenAddCardHolder(true)}
                />
            </OreveFooter>
        </Box>
    )
}
